import http from './common/http-service';
import axios from 'axios';
export class ResourceCategorySummaryService {
    async Get() {
        try {
            const { data, status } = await http.get('/categories');
            return data;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                console.log('error message: ', error.message);
            }
            else {
                console.log('unexpected error: ', error);
            }
            return [];
        }
    }
}
